"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromBn = void 0;
var bignumber_1 = require("@ethersproject/bignumber");
/**
 * Convert a big number with a custom number of decimals to a stringified fixed-point number.
 */
function fromBn(x) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 18;
  if (x === undefined) {
    throw new Error("Input must not be undefined");
  }
  if (decimals < 1 || decimals > 77) {
    throw new Error("Decimals must be between 1 and 77");
  }
  var result = bignumber_1.FixedNumber.fromValue(x, decimals, "fixed256x".concat(decimals)).toString();
  return result.replace(/.0$/, "");
}
exports.fromBn = fromBn;